import { ButtonHTMLAttributes } from 'react';
import { motion } from 'framer-motion';

interface GradientButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md' | 'lg';
}

export default function GradientButton({ children, className = '', size = 'md', ...props }: GradientButtonProps) {
  const sizes = { sm: 'px-4 py-1.5 text-sm', md: 'px-6 py-2.5 text-sm', lg: 'px-8 py-3 text-base' };
  return (
    <motion.button
      whileTap={{ scale: 0.97 }}
      whileHover={{ scale: 1.02 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      className={`bg-primary text-white font-semibold rounded-full hover:bg-primary-dark transition-colors ${sizes[size]} ${className}`}
      {...(props as any)}
    >
      {children}
    </motion.button>
  );
}
